import { CodeBase} from "./_codeBase";

/**
 * 文字方向区分
 */
export class TextDirectionDiv extends CodeBase<TextDirectionDiv>
{
    /** 文字方向区分 "01", "横" */
    public static readonly TEXT_DIRECTION_HORIZONTAL: TextDirectionDiv = new TextDirectionDiv("01", "横");
    /** 文字方向区分 "02", "縦" */
    public static readonly TEXT_DIRECTION_VERTICAL: TextDirectionDiv = new TextDirectionDiv("02", "縦");
   

    /**
     * 
     * @param value
     * @param text
     */
    protected constructor(value: any, text: string, abbr?: any) {
        super(value, text, abbr);
    }

    /**
     * 
     */
    public static List(): TextDirectionDiv[] {
        return [
            TextDirectionDiv.TEXT_DIRECTION_HORIZONTAL,
            TextDirectionDiv.TEXT_DIRECTION_VERTICAL,
        ];
    }
}
